import React from "react";
import Header from "../../../Home/Header";
import Footer from "../../../Home/Footer";
import TezosHero from "./TezosHero";
import WhyTezosPowers from "./WhyTezosPowers";
import Governance from "./Governance";
import SmartContracts from "./SmartContracts";

function Tezos() {
  return (
    <div>
      <Header />
      <TezosHero />
      <WhyTezosPowers />
      <Governance />
      <SmartContracts />
      <Footer />
    </div>
  );
}

export default Tezos;
